<div class="sidebar" [ngClass]="{ expanded: isExpanded, hidden: !(showMenu() | async), show: (showMenu() | async) }">
  <div class="menu-list">
    <div>
      <ng-container>
        <div
          #listItem
          data-href="/future-order"
          class="menu-item"
          [ngClass]="{ 'menu-item--active': getIsHomePage('/future-order') }"
          (click)="onMenuItemClick($event)"
          >
          <ion-icon class="menu-icon" name="calendar-outline"></ion-icon>
          <div class="menu-title">Future Order Tool</div>
        </div>
      </ng-container>
      @if (showMenuItem('forecast-lab:user') | async) {
        <div
          #listItem
          data-href="/"
          class="menu-item"
          [ngClass]="{ 'menu-item--active': getIsHomePage('/') }"
          (click)="onMenuItemClick($event)"
          >
          <ion-icon class="menu-icon" name="trending-up"></ion-icon>
          <div class="menu-title">Forecast Lab</div>
        </div>
      }
      @if (showMenuItem('forecast-lab:user') | async) {
        <div
          #listItem
          data-href="/material-mapping"
          class="menu-item"
          [ngClass]="{ 'menu-item--active': getIsHomePage('/material-mapping') }"
          (click)="onMenuItemClick($event)"
          >
          <ion-icon class="menu-icon" name="swap-horizontal-outline"></ion-icon>
          <div class="menu-title">Material Mapping</div>
        </div>
      }
      @if (showMenuItem('forecast-lab:user') | async) {
        <div
          #listItem
          data-href="/innovation-prediction"
          class="menu-item"
          [ngClass]="{ 'menu-item--active': getIsHomePage('/innovation-prediction') }"
          (click)="onMenuItemClick($event)"
          >
          <ion-icon class="menu-icon" name="bulb-outline"></ion-icon>
          <div class="menu-title">Innovation Prediction</div>
        </div>
      }
    </div>
    <div>
      <ng-container>
        <!-- <app-cona-tooltip text="Download User Manual" position="top-left"> -->
        <div
          class="menu-item last-item faded-separator-white"
          [ngClass]="'menu-item--active'"
          (click)="downloadManualAssets()"
          [style.pointer-events]="isManualDownloading ? 'none' : 'auto'"
          >
          @if (isManualDownloading) {
            <ion-spinner
              class="menu-icon"
              style="display: flex; justify-content: center; margin: auto; height: 18px; width: 24px"
              slot="start"
              name="crescent"
            ></ion-spinner>
          } @else {
            <img style="width: 24px" src="/assets/book-icon.svg" alt="book-icon" />
            <div class="menu-title">User Manual</div>
          }
        </div>
      <!-- </app-cona-tooltip> -->
    </ng-container>
  </div>
</div>

<div class="highlighter" [ngStyle]="{ 'top.px': highlighterPos + 7 }"></div>

<!-- The toggle button remains in place -->
<!-- <div class="toggle-btn" (click)="toggleSidebar()">
<ion-icon name="chevron-forward-outline"></ion-icon>
</div> -->
</div>
